import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames/bind';
import { images } from '../../../../../images/exported';
import styles from '../index.scss';
import { watermarkTypes } from '../../../../../constants';
const cx = classnames.bind(styles);
const ImageWatermark = ({ type }) => {
    let targetImage;
    switch (type) {
        case watermarkTypes.SmartSale:
            targetImage = images.smartsaleOverlay;
            break;
        default:
            targetImage = null;
    }
    if (!targetImage) {
        return null;
    }
    return (_jsx("div", { className: cx('watermark-container'), children: _jsx("div", { className: cx('watermark-image'), style: { backgroundImage: `url(${targetImage})` } }) }));
};
export default ImageWatermark;
//# sourceMappingURL=index.js.map